/* global theme */
/* Optimist: Tafel-Aktion – Kaffeesack-Box im Warenkorb (siehe snippets/tafel-upsell.liquid) */

if (!customElements.get('tafel-upsell')) {
  class TafelUpsell extends HTMLElement {
    connectedCallback() {
      if (this.dataset.hideFrom) {
        const today = new Intl.DateTimeFormat('sv-SE', { timeZone: 'Europe/Berlin' }).format(new Date());
        if (today >= this.dataset.hideFrom) {
          this.hidden = true;
          return;
        }
      }

      this.max = parseInt(this.dataset.max, 10) || 1;
      this.unitPrice = parseInt(this.dataset.price, 10) || 0;
      this.qty = 1;
      this.countEl = this.querySelector('.tafel-upsell__count');
      this.priceEl = this.querySelector('.tafel-upsell__price');
      this.addBtn = this.querySelector('.tafel-upsell__add');
      this.errorEl = this.querySelector('.tafel-upsell__error');
      this.steps = this.querySelectorAll('.tafel-upsell__step');

      this.steps.forEach((btn) => {
        btn.addEventListener('click', (evt) => {
          evt.preventDefault();
          this.qty = Math.min(this.max, Math.max(1, this.qty + parseInt(btn.dataset.step, 10)));
          this.render();
        });
      });
      this.addBtn.addEventListener('click', this.add.bind(this));
      this.render();
    }

    render() {
      this.countEl.textContent = this.qty;
      this.priceEl.textContent = ((this.unitPrice * this.qty) / 100)
        .toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
      this.steps[0].disabled = this.qty <= 1;
      this.steps[1].disabled = this.qty >= this.max;
    }

    async add(evt) {
      evt.preventDefault();
      this.addBtn.classList.add('is-loading');
      this.addBtn.disabled = true;
      this.errorEl.hidden = true;

      const cartDrawer = this.closest('cart-drawer');
      const formData = new FormData();
      formData.append('id', this.dataset.variantId);
      formData.append('quantity', this.qty);
      formData.append('sections_url', window.location.pathname);
      formData.append('sections', cartDrawer ? `${cartDrawer.dataset.section},cart-icon-bubble` : 'cart-icon-bubble');

      try {
        const response = await fetch(theme.routes.cartAdd, {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        });
        const data = await response.json();
        if (!response.ok) {
          throw new Error(typeof data.description === 'string' ? data.description : data.message);
        }

        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          // Baut Drawer-Inhalt + Warenkorb-Zähler neu auf (wie product-form.js).
          cartDrawer.renderContents(data, false);
        } else {
          window.location.reload();
        }
      } catch (error) {
        this.errorEl.textContent = error.message || theme.strings.cartError;
        this.errorEl.hidden = false;
        this.addBtn.classList.remove('is-loading');
        this.addBtn.disabled = false;
      }
    }
  }

  customElements.define('tafel-upsell', TafelUpsell);
}
